import mixpanel from "mixpanel-browser";
import { omitEmpty, type AnalyticsProps } from "./props";

let ready = false;

export function initMixpanel({ token }: { token?: string }) {
  if (!token || typeof window === "undefined") return;
  try {
    mixpanel.init(token, {
      track_pageview: false,
      persistence: "localStorage",
      ignore_dnt: false,
    });
    ready = true;
  } catch {
    // never break UX for analytics
  }
}

export function track(event: string, properties?: AnalyticsProps) {
  if (!ready) return;
  try {
    mixpanel.track(event, omitEmpty(properties));
  } catch {
    // ignore
  }
}

export function identify(userId: string, traits?: AnalyticsProps) {
  if (!ready) return;
  try {
    mixpanel.identify(userId);
    const props = omitEmpty(traits);
    if (Object.keys(props).length) {
      mixpanel.people.set(props);
    }
  } catch {
    // ignore
  }
}

export function group(
  groupType: string,
  groupKey: string,
  traits?: AnalyticsProps
) {
  if (!ready) return;
  try {
    mixpanel.set_group(groupType, groupKey);
    const props = omitEmpty(traits);
    if (Object.keys(props).length) {
      mixpanel.get_group(groupType, groupKey).set(props);
    }
  } catch {
    // ignore
  }
}

export function page(name?: string, properties?: AnalyticsProps) {
  if (!ready) return;
  try {
    mixpanel.track(
      "Page View",
      omitEmpty({
        ...(name ? { page_name: name } : {}),
        ...properties,
      })
    );
  } catch {
    // ignore
  }
}

export function reset() {
  if (!ready) return;
  try {
    mixpanel.reset();
  } catch {
    // ignore
  }
}
